import React from 'react';
import { useAuth } from '../App';

export default function PromoThankYou() {
  const { navigate } = useAuth();

  return (
    <div className="min-h-[calc(100vh-80px)] flex items-center justify-center px-4 py-12">
      <div className="max-w-2xl w-full">

        {/* Success Icon */}
        <div className="text-center mb-8">
          <div className="w-24 h-24 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-8">
            <svg className="w-12 h-12 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>

          <h1 className="font-display text-3xl md:text-4xl text-navy-900 mb-3">
            Thank You for Joining!
          </h1>
          <p className="text-xl text-navy-600 font-body">
            Your introductory offer purchase is confirmed.
          </p>
        </div>

        {/* Email Check */}
        <div className="bg-white border border-coral-200 rounded-xl p-6 mb-8">
          <h2 className="font-display text-lg text-navy-900 mb-2">
            Check Your Email for Login Details
          </h2>
          <p className="text-navy-700 font-body mb-4">
            We've sent you an email with a link to set your password and access your advisor portal. Please check your inbox, and if you don't see it, check your spam/junk folder.
          </p>
          <div className="bg-cream-50 rounded-lg p-4">
            <p className="text-navy-700 font-body text-sm mb-2">
              Your leads will be delivered by email, so please add the following address to your safe senders list to make sure you never miss one:
            </p>
            <p className="text-navy-900 font-mono text-base font-bold">
              leads@thedeolixacademy.com
            </p>
          </div>
        </div>

        {/* What Happens Next */}
        <div className="card-elevated mb-8">
          <h2 className="font-display text-xl text-navy-900 mb-4">What Happens Next</h2>
          <div className="space-y-4">
            <div className="flex items-start gap-4">
              <span className="w-8 h-8 bg-coral-500 text-white rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0 mt-0.5">1</span>
              <div>
                <p className="font-medium text-navy-900">Set your password</p>
                <p className="text-navy-600 font-body text-sm">Click the link in your welcome email to create your password and log in to your advisor portal.</p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <span className="w-8 h-8 bg-coral-500 text-white rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0 mt-0.5">2</span>
              <div>
                <p className="font-medium text-navy-900">Your account is ready</p>
                <p className="text-navy-600 font-body text-sm">Your account has been created with 6 leads (3 + 3 bonus). They'll be delivered at 3 leads per week over the next 2 weeks. If you'd like them delivered faster or slower, you can adjust the delivery pace in the Settings section of your dashboard.</p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <span className="w-8 h-8 bg-coral-500 text-white rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0 mt-0.5">3</span>
              <div>
                <p className="font-medium text-navy-900">Watch your inbox</p>
                <p className="text-navy-600 font-body text-sm">You'll receive your first lead by email within the next few days. Each lead includes the client's name, email, phone number (if provided), and their trip details.</p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <span className="w-8 h-8 bg-coral-500 text-white rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0 mt-0.5">4</span>
              <div>
                <p className="font-medium text-navy-900">Reach out quickly</p>
                <p className="text-navy-600 font-body text-sm">When you receive a lead, contact them as soon as possible. Check out the Training section in your portal for our proven follow-up system to maximize your response rate.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Login Button */}
        <div className="text-center">
          <p className="text-navy-600 font-body mb-4">
            Already set your password?
          </p>
          <button 
            onClick={() => navigate('/login')} 
            className="btn-primary px-8 py-3"
          >
            Log In to Your Portal
          </button>
        </div>

      </div>
    </div>
  );
}
